import * as React from "react";
import { menuData, snsData } from "../data";
import { getLocalizedText } from "../util";
import { useLang } from "../lang";

type MenuProps = {
  onNavigate?: () => void;
};

const Menu: React.FC<MenuProps> = ({ onNavigate }) => {
  const { langEn } = useLang();
  return (
    <aside id="colorlib-aside" role="complementary" className="js-fullheight text-right">
      <h1 id="colorlib-logo" className="hidden-md">
        <a href="#top" onClick={onNavigate}>
          Kei18
        </a>
      </h1>
      <nav id="colorlib-main-menu" role="navigation">
        <ul>
          {menuData.menu.map((item) => (
            <li key={item.id} className={item.className}>
              <a href={item.href} onClick={onNavigate}>
                {getLocalizedText(item.label, langEn)}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="colorlib-footer">
        <ul>
          {snsData.map((item, i) => (
            <li key={i}>
              <a href={item.url} onClick={onNavigate}>
                <i className={"academic-icon ai icon " + item.name}></i>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Menu;
